<template>

  <el-dialog v-model="dialogVisible" title="数据中间件（输出）" :close-on-click-modal="false" width="920px"
             style="border-radius: 10px"
             append-to-body>
    <el-table ref="table" row-key="name" border :data="columns"
              style="width: 100%;"
              :header-cell-style="{color:'black'}"
              size="small" :tree-props="{checkStrictly:false}"
              @selection-change="handleSelectionChange" max-height="calc(100vh - 360px)">
      <el-table-column type="selection" width="35px" prop="select" :reserve-selection="true" :selectable="(row)=>{
     return row.tag!=='id';
    }"></el-table-column>
      <el-table-column label="名称" prop="name" align="center">
        <template #default="scope">
          <span>{{ scope.row.name }}</span>
          <el-tag style="margin-left: 10px">{{ scope.row.nodeName }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="别名" :width="200" align="center">
        <template #default="scope">
          <el-input v-model="scope.row.alias" size="small" :key="scope.row.name" @change="(val)=>{
          let match = node.attrs.keepColumns.find(find => find.name === scope.row.name);
          if(match)
          match.alias = val;
        }"></el-input>
        </template>
      </el-table-column>
      <el-table-column width="50px"></el-table-column>
    </el-table>
  </el-dialog>

</template>

<script>

import {mapStores} from "pinia";
import {useEtlStore} from "@/stores/etl";

export default {
  computed: {
    ...mapStores(useEtlStore)
  },
  props: {
    isFullscreen: {
      type: Boolean,
      default: () => false,
    }
  },
  data() {
    return {
      dialogVisible: false,
      node: null,
      data: null,
      columns: [],
      keyword: '',
      multipleSelection: [],
    }
  },
  methods: {
    call(node, data) {
      this.multipleSelection = [];
      this.columns = [];
      this.keyword = '';
      this.node = node;
      this.data = data;
      this.dialogVisible = true;
      this.$nextTick(async () => {
        await this.initColumns();
        this.select()
      })
    },
    async initColumns() {
      await this.etlStore.getNodeColumns(this.node.id, this.data).then(res => {
        if (res.code === 200) {
          this.columns = res.data.map(mapper => {
            return {
              name: mapper.name,
              nodeName: mapper.nodeName,
              nodeType: mapper.nodeType
            }
          });
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.save()
    },
    save() {
      this.$nextTick(() => {
        this.node.attrs.keepColumns = this.multipleSelection.map(mapper => {
          return {
            name: mapper.name,
            alias: mapper.alias ? mapper.alias : '',
          }
        });
      })
    },
    select() {
      let rows = this.node.attrs.keepColumns;
      let names = rows.map(mapper => mapper.name);
      this.columns.forEach((row) => {
        let selected = names.includes(row.name);
        this.$refs.table.toggleRowSelection(row, selected)
      });
    }

  }
}
</script>

<style scoped lang="scss">
:deep(.el-tag) {
  margin: 4px;
}

:deep(.el-table ) {
  padding: 10px;
}

:deep(.el-table thead) {
  color: #1F1C2C;
}

</style>
